import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "border-bottom-color"
    }}>{`border-bottom-color`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v2.0`}</p>
    <p>{`Specifies the top border color for an element. Supported color formats are as follows:`}</p>
    <ul>
      <li parentName="ul">{`Named Colors (See `}<a parentName="li" {...{
          "href": "https://github.com/colorjs/color-name/blob/master/index.js"
        }}>{`https://github.com/colorjs/color-name/blob/master/index.js`}</a>{`)`}</li>
      <li parentName="ul">{`Hex colors`}</li>
      <li parentName="ul">{`RGB and RGBA colors`}</li>
      <li parentName="ul">{`HSL and HSLA colors`}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en/docs/Web/CSS/color"
        }}>{`https://developer.mozilla.org/en/docs/Web/CSS/color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/colorjs/color-name/blob/master/index.js"
        }}>{`https://github.com/colorjs/color-name/blob/master/index.js`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    border-style: solid;
    border-bottom-color: blue;
}
`}</code></pre>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul">{`Not all Spectrum UXP components allow color overrides.`}</li>
      <li parentName="ul">{`When specifying a border color, the border must also include a border style.`}</li>
      <li parentName="ul">{`Borders can only support a single color; the last specified border color will take precedence.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      